import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { quizTopics } from "../../data/quizData";
import "./Quiz.css";

const QuizDashboard = () => {
    const [selectedTopicId, setSelectedTopicId] = useState(null);
    const navigate = useNavigate();

    const handleCardClick = (id) => {
        setSelectedTopicId(id);
    };

    const handleStartQuiz = () => {
        if (selectedTopicId) {
            navigate(`/quiz/game/${selectedTopicId}`);
        }
    };

    return (
        <div className="quiz-dashboard-container">
            <div className="quiz-header" data-aos="fade-down">
                <h1>Quiz Dashboard</h1>
                <p>Select a topic to start testing your knowledge</p>
            </div>

            <div className="quiz-grid">
                {quizTopics.map((topic) => (
                    <div
                        key={topic.id}
                        className={`quiz-card ${selectedTopicId === topic.id ? "selected" : ""}`}
                        onClick={() => handleCardClick(topic.id)}
                    >
                        <div className="quiz-card-content">
                            <h3>{topic.title}</h3>
                            <p>{topic.description}</p>
                        </div>
                        <div className="quiz-meta">
                            <span>{topic.questions.length} Questions</span>
                        </div>
                    </div>
                ))}
            </div>

            <button
                className={`next-action-btn ${!selectedTopicId ? "disabled" : ""}`}
                onClick={handleStartQuiz}
                disabled={!selectedTopicId}
            >
                Next
            </button>
        </div>
    );
};

export default QuizDashboard;
